export const getters = {
  getModalSendArchive: state => state.modalSendArchive,
  getLinks: state => state.links,
  getCurrentLinkInfo: state => state.currentLinkInfo,
  getPercentageSentArchive: state => state.percentageSentArchive,
  getModalGlobalMessage: state => state.modalGlobalMessage,
  getModalConfirmAction: state => state.modalConfirmAction,
  getModalLoading: state => state.modalLoading
};

export default {};
